import { Controller } from "@hotwired/stimulus"

// Selects a read-only field's whole value on click, ready to copy (share links,
// snippets). data-controller="select-text" data-action="click->select-text#select"
// on the input. Replaces onclick="this.select()", which the enforcing CSP blocks.
export default class extends Controller {
    select() {
        this.element.select()
    }
}
